import type { ComplianceLoginData, ComplianceUserInfoData } from './complianceAuthApi';
import { getToken } from '@/utils/utils';

const DEFAULT_AVATAR =
  'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png';

/**
 * 与 xPredictorWeb mapComplianceToCurrentUser 一致，并补全 MassPayment 布局用到的字段
 */
export function mapComplianceToCurrentUser(
  payload: ComplianceLoginData | ComplianceUserInfoData,
): API.CurrentUser {
  const token = getToken();
  const isLoginShape = (p: ComplianceLoginData | ComplianceUserInfoData): p is ComplianceLoginData =>
    'name' in p && p.name !== undefined;

  const name = isLoginShape(payload) ? payload.name : payload.username;
  const userId = payload.userId;

  const roles =
    Array.isArray(payload.roles) && payload.roles.length > 0
      ? payload.roles
      : ['partner', 'partnerDirectCustomer'];

  return {
    userid: userId,
    name: name || payload.email || userId,
    email: payload.email,
    roles,
    token: token || undefined,
    avatar: DEFAULT_AVATAR,
    signature: '',
    title: '',
    group: '',
    tags: [],
    notifyCount: 0,
    unreadCount: 0,
    country: 'China',
    access: roles[0],
    geographic: {
      province: { label: '', key: '' },
      city: { label: '', key: '' },
    },
    address: '',
    phone: '',
    merchant: {} as API.CurrentUser['merchant'],
  };
}
